import React from 'react'
import { func, shape } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Autosuggest, QuickGlanceOverlay } from '@fs/zion-ui'
import { trackEvent } from '@fs/zion-analytics'
import { useDSCDispatch, ACTIONS } from '../../../state/DSCStore'
import { useRegionLanguage } from '../hooks/hooks'

export default function AAMCountrySelector({ overlay }) {
  const { t } = useTranslation()
  const countryLanguageOptions = useRegionLanguage(t)
  const dispatch = useDSCDispatch()

  const suppressAutocomplete = (event) => {
    event.target.setAttribute('autocomplete', 'disabled')
  }

  const onSuggestionSelected = (selection) => {
    if (selection) {
      dispatch({
        type: ACTIONS.UPDATE_LANGUAGE,
        data: {
          countryLang: selection,
        },
      })
      trackEvent({ event_name: 'AAMCountrySelector:COUNTRY_LANGUAGE_SELECTED:CLICK' })
      overlay.close()
      window.location.reload()
    }
  }

  const autoSuggestProps = {
    placeholder: t('aam-landing-validation-select-country-language'),
    suggestions: countryLanguageOptions,
    onSuggestionSelected,
  }

  return (
    <QuickGlanceOverlay
      {...overlay}
      fullscreen
      title={t('aam.content.country.select', 'Select A Different Country Or Language')}
    >
      <div style={{ height: '300px' }}>
        <Autosuggest
          inputProps={{
            onFocus: suppressAutocomplete,
          }}
          {...autoSuggestProps}
        />
      </div>
    </QuickGlanceOverlay>
  )
}

AAMCountrySelector.propTypes = {
  overlay: shape({
    close: func,
  }).isRequired,
}
